import { Maybe, VxlIconKey } from '@varo/graphql-schema-types';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import theme from 'shared/styles/theme';

interface CalloutBannerProps {
  message: string;
  iconKey?: Maybe<VxlIconKey> | undefined;
}

const CalloutBanner = ({ message, iconKey }: CalloutBannerProps) => {
  return (
    <View style={styles.calloutContainer}>
      {iconKey ? <Icon iconKey={iconKey} iconSize="MD" /> : null}
      <View style={styles.calloutMessageContainer}>
        <BodySmText numberOfLines={0}>{message}</BodySmText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  calloutContainer: {
    alignItems: 'center',
    backgroundColor: theme.color.status.infoLight,
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing.s,
    padding: theme.spacing.m,
  },
  calloutMessageContainer: {
    flexShrink: 1,
  },
});

export default CalloutBanner;
